import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  effect,
  ElementRef,
  HostListener,
  inject,
  Injector,
  input,
  model,
  runInInjectionContext,
} from '@angular/core';

@Component({
  selector: 'app-modal',
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  open = model<boolean>(false);

  // Título del modal
  title = input<string>('');

  // Permitir cerrar al hacer click en el fondo
  closeOnBackdropClick = input<boolean>(true);

  private readonly doc = inject(DOCUMENT);
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly injector = inject(Injector);
  public readonly titleId = `modal-title-${Math.random().toString(36).slice(2)}`;

  constructor() {
    // Bloquear/desbloquear scroll del body y enfocar al abrir (tengo que probar si funciona bien)
    effect(() => {
      if (this.open()) {
        this.doc.body.style.overflow = 'hidden';

        runInInjectionContext(this.injector, () => {
          afterNextRender(() => {
            const dialog = this.host.nativeElement.querySelector('.modal__dialog') as HTMLElement | null;
            dialog?.focus?.();
          });
        });
      } else {
        this.doc.body.style.overflow = '';
      }
    });
  }

  // Con esto cerramos con tecla la ESC
  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.open()) this.close();
  }

  onBackdropClick() {
    if (this.closeOnBackdropClick()) this.close();
  }

  close() {
    this.open.set(false);
  }
}
